import { Button } from '@cokitchen/cokitchen-components';
import React from 'react';

const AuthLayout = ({
  title,
  subtitle,
  children,
  onConfirm,
  onConfirmText = 'Confirm',
  loading,
  subText,
  disabled,
  hideButton
}: {
  title: string;
  subtitle?: string;
  children: any;
  onConfirm?: (arg0: any) => void;
  onConfirmText?: string;
  loading?: boolean;
  subText?: any;
  disabled?: boolean;
  hideButton?: boolean;
}) => {
  return (
    <div className='min-w-full'>
      <div className='mx-auto max-w-[400px] mb-[64px]'>
        <p className='text-[32px] font-semibold mb-3 tracking-minus-0.4'>{title}</p>
        <p className='text-[#6F7376] text-[16px] mb-[44px]'>{subtitle}</p>
        <div>{children}</div>
      </div>
      {!hideButton && (
        <Button
          small
          color='primary'
          className='mx-auto'
          variant='block'
          onClick={onConfirm}
          loading={loading}
          disabled={disabled}>
          {onConfirmText}
        </Button>
      )}
      <div className='text-center'>{subText}</div>
    </div>
  );
};

export default AuthLayout;
